import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
import { translate } from '../utils/translations';

export default function EmployeeTimeline({ employeeId }: { employeeId: string }) {
  const [items, setItems] = useState<any[]>([]);
  useEffect(() => {
    apiClient
      .get(`/reports/employees/${employeeId}/timeline`)
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, [employeeId]);
  return (
    <section className="employee-documents" style={{ width: '100%' }}>
      <div className="panel-heading">
        <div>
          <h2>Línea de tiempo</h2>
          <p>Actividad laboral y documental del legajo, en orden cronológico.</p>
        </div>
      </div>
      {!items.length ? (
        <div className="empty-state">Todavía no hay eventos.</div>
      ) : (
        <div style={{ borderLeft: '2px solid var(--border)', marginLeft: 8, paddingLeft: 22 }}>
          {items.map((item, index) => (
            <article
              key={`${item.date}-${index}`}
              style={{ position: 'relative', paddingBottom: 18 }}
            >
              <span
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: 'var(--accent)',
                  left: -28,
                  top: 5,
                }}
              />
              <small style={{ color: 'var(--text-muted)' }}>
                {new Date(item.date).toLocaleString('es-AR')}
              </small>
              <strong style={{ display: 'block', margin: '3px 0' }}>
                {item.event} · {item.type}
              </strong>
              <span style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
                {item.detail} — {translate(item.status)}
              </span>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
